<div id="commercial-outage-information-container">
  <form [formGroup]="form()!" id="commercial-outage-form">
    <div id="general-info">
      <p-panel
        header="{{ 'COMMERCIAL_SERVICES.LABEL.GENERAL_INFO' | translate }}"
        [toggleable]="true"
        toggler="header"
      >
        <div>
          <div class="row facility-row">
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="commercialFacilityId"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.FACILITY' | translate }}
                <span class="required">*</span>
              </label>
              <div class="row-input">
                <p-select
                  inputId="commercialFacilityId"
                  (onChange)="facilitySelected.emit($event.value ?? null)"
                  [options]="availableFacilities()"
                  formControlName="commercialFacilityId"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  appendTo="body"
                />
                <app-inline-validation
                  field="commercialFacilityId"
                  [control]="form()!.controls['commercialFacilityId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row-item">
              <label class="row-label commercial-outage-form-label" for="aorId">
                {{ 'COMMERCIAL_SERVICES.LABEL.AOR' | translate }}
              </label>
              <div class="row-input">
                <p-select
                  inputId="aorId"
                  [options]="availableAors()"
                  formControlName="aorId"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  appendTo="body"
                  (onChange)="facilityFiltersChanged.emit()"
                />
                <app-inline-validation
                  field="aorId"
                  [control]="form()!.controls['aorId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="commercialOperatingAreaId"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.OPERATING_AREA' | translate }}
              </label>
              <div class="row-input">
                <p-select
                  inputId="commercialOperatingAreaId"
                  [options]="availableOperatingAreas()"
                  formControlName="commercialOperatingAreaId"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  appendTo="body"
                  (onChange)="operatingAreaChanged.emit($event.value ?? null)"
                />
                <app-inline-validation
                  field="commercialOperatingAreaId"
                  [control]="form()!.controls['commercialOperatingAreaId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="commercialMarketAreaId"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.MARKET_AREA' | translate }}
              </label>
              <div class="row-input">
                <p-select
                  inputId="commercialMarketAreaId"
                  [options]="availableMarketAreas()"
                  formControlName="commercialMarketAreaId"
                  optionLabel="label"
                  optionValue="value"
                  [filter]="true"
                  [disabled]="
                    !form()!.controls['commercialOperatingAreaId'].value
                  "
                  appendTo="body"
                  (onChange)="facilityFiltersChanged.emit()"
                />
                <app-inline-validation
                  field="commercialMarketAreaId"
                  [control]="form()!.controls['commercialMarketAreaId']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="numberOfTotalUnits"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.TOTAL_UNITS' | translate }}
                <span class="required">*</span>
              </label>
              <div class="row-input">
                <p-inputNumber
                  inputId="numberOfTotalUnits"
                  mode="decimal"
                  [showButtons]="true"
                  [step]="1"
                  [min]="0"
                  [maxFractionDigits]="0"
                  formControlName="numberOfTotalUnits"
                />
                <app-inline-validation
                  field="numberOfTotalUnits"
                  [control]="form()!.controls['numberOfTotalUnits']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row outage-details-row">
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="outageStartDate"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.START_DATE' | translate }}
                <span class="required">*</span>
              </label>
              <div class="row-input">
                <p-datepicker
                  inputId="outageStartDate"
                  formControlName="outageStartDate"
                  dateFormat="mm/dd/yy"
                  [showIcon]="true"
                  appendTo="body"
                />
                <app-inline-validation
                  field="outageStartDate"
                  [control]="form()!.controls['outageStartDate']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="numberOfUnitsOnOutage"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.UNITS_ON_OUTAGE' | translate }}
                <span class="required">*</span>
              </label>
              <div class="row-input">
                <p-inputNumber
                  inputId="numberOfUnitsOnOutage"
                  mode="decimal"
                  [showButtons]="true"
                  [step]="1"
                  [min]="0"
                  [maxFractionDigits]="0"
                  formControlName="numberOfUnitsOnOutage"
                />
                <app-inline-validation
                  field="numberOfUnitsOnOutage"
                  [control]="form()!.controls['numberOfUnitsOnOutage']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row end-date-row">
            <div class="row-item">
              <label
                class="row-label commercial-outage-form-label"
                for="outageEndDate"
              >
                {{ 'COMMERCIAL_SERVICES.LABEL.END_DATE' | translate }}
                <span class="required">*</span>
              </label>
              <div class="row-input">
                <p-datepicker
                  inputId="outageEndDate"
                  formControlName="outageEndDate"
                  dateFormat="mm/dd/yy"
                  [showIcon]="true"
                  appendTo="body"
                />
                <app-inline-validation
                  field="outageEndDate"
                  [control]="form()!.controls['outageEndDate']"
                  [validationMessages]="validationMessages()"
                />
              </div>
            </div>
          </div>

          <div class="row comments-row">
            <div class="row-item comments-item">
              <label class="row-label commercial-outage-form-label" for="notes">
                {{ 'CRM.LABEL.COMMENTS' | translate }}
              </label>
              <div class="row-input">
                <textarea
                  id="notes"
                  pTextarea
                  [rows]="4"
                  formControlName="notes"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </form>
</div>
